import React, { useState, useEffect } from 'react';

const LoginRewardToast = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');
  const [amount, setAmount] = useState(0);

  useEffect(() => {
    const handleLoginReward = (event) => {
      setMessage(event.detail.message);
      setAmount(event.detail.amount || 200);
      setVisible(true);
      
      // Hide the toast after 5 seconds
      const timer = setTimeout(() => {
        setVisible(false);
      }, 5000);
      
      return () => clearTimeout(timer);
    };
    
    window.addEventListener('login-reward', handleLoginReward);
    
    return () => {
      window.removeEventListener('login-reward', handleLoginReward);
    };
  }, []);
  
  if (!visible) return null;
  
  return (
    <div className="fixed bottom-4 right-4 bg-gradient-to-r from-green-500 to-blue-500 text-white py-3 px-4 rounded-lg shadow-lg max-w-xs">
      <div className="flex items-start">
        <div className="flex-shrink-0 mr-3">
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
        </div>
        <div className="flex-1">
          <div className="flex justify-between items-start">
            <div>
              <div className="font-bold text-lg">Daily Reward!</div>
              <div className="text-sm opacity-90">{amount.toLocaleString()} coins</div>
            </div>
            <button 
              onClick={() => setVisible(false)}
              className="text-white ml-3"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginRewardToast; 